module.exports = __webpack_public_path__ + "static/media/SiteLinksExample@3x.d0f9b23812fdd4f9180aa0185fc1f0a7.jpg";